import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSub = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 11.3658,
			r: 10,
			fill: "#131924",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8102 10.1516H3.81016H2.41016L6.61016 5.86584L10.8102 10.1516Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0102 12.5801L17.0102 12.5801L18.4102 12.5801L14.2102 16.8658L10.0102 12.5801Z",
			fill: "white"
		})
	]
});
export default SvgSub;
